import React, { useEffect, useState } from 'react';
import SiteLayout from '../components/SiteLayout';
import GumballIcon from '../components/GumballIcon';
import { publicApi } from '../api/client';
import './announcements.css';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'updates', label: 'Updates' },
  { key: 'events', label: 'Events' },
  { key: 'roadmap', label: 'Roadmap' },
  { key: 'community', label: 'Community' },
];

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString(undefined, {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}

export default function AnnouncementsPage() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    setLoading(true);
    const query = filter === 'all' ? undefined : filter;
    publicApi.getAnnouncements(query)
      .then(setItems)
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [filter]);

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <SiteLayout pageClass="announcements-page">
      <div className="public-page-wrap">
        <a href="/" className="public-back-link">
          <GumballIcon name="home" size={18} /> Back to Home
        </a>

        <header className="public-page-header">
          <span className="section-eyebrow">Official Updates</span>
          <h1 className="public-page-title">Announcements</h1>
          <p className="public-page-lead">News, events, and updates from the Gumball Buddies universe.</p>
        </header>

        <div className="filter-pills" role="tablist" aria-label="Filter announcements">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              type="button"
              role="tab"
              aria-selected={filter === f.key}
              className={`filter-pill ${filter === f.key ? 'active' : ''}`}
              onClick={() => setFilter(f.key)}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading && <p className="public-loading">Loading announcements...</p>}

        {!loading && !items.length && (
          <div className="public-empty glass-card">
            <GumballIcon name="megaphone" size={40} />
            <h2>No announcements yet</h2>
            <p>Check back soon for official Gumball Buddies updates.</p>
            <a href="/" className="cta-btn cta-secondary">Return Home</a>
          </div>
        )}

        {!loading && items.length > 0 && (
        <div className="announcements-feed">
          {items.map((item) => {
            const isOpen = expanded[item.id];
            const hasMore = item.content
              && item.preview_text
              && item.content.trim().length > item.preview_text.trim().length;
            return (
              <article key={item.id} className="announcement-feed-card glass-card">
                {item.image_url && (
                  <div className="announcement-feed-image">
                    <img src={item.image_url} alt="" loading="lazy" />
                  </div>
                )}
                <div className="announcement-feed-body">
                  <div className="announcement-feed-meta">
                    <span className={`category-tag category-${item.category}`}>{item.category}</span>
                    <time dateTime={item.publish_date}>{formatDate(item.publish_date)}</time>
                  </div>
                  <h2 className="announcement-feed-title">{item.title}</h2>
                  <p className="announcement-feed-preview">
                    {isOpen ? item.content : item.preview_text}
                  </p>
                  {hasMore && (
                    <button
                      type="button"
                      className="announcement-expand-btn"
                      onClick={() => toggleExpand(item.id)}
                    >
                      {isOpen ? 'Show less' : 'Read full update'}
                    </button>
                  )}
                </div>
              </article>
            );
          })}
        </div>
        )}
      </div>
    </SiteLayout>
  );
}
